import React, { useEffect, useState } from 'react'
import { IVUobjectData } from './DrillThru';
import { FoundationsConstants } from '../../FoundationsConstants';

interface IAutoRefreshProps {
vuid: number,
onRefresh: Function,
refreshInterval: number,
drillThruObjRef: IVUobjectData
}

const AutoRefreshTimer = (props : IAutoRefreshProps) => {
     const [remainingTime, setRemainingTime] = useState(0); // in seconds
     const [refreshPaused, setRefreshPaused] = useState(false); // in seconds

     const toggleDrillthruAutoRefresh =()=>{
        setRefreshPaused(prev => !prev);
     }

    useEffect(() => {
        // Reset timer whenever refresh interval changes
        setRemainingTime(props.refreshInterval * 60);
    }, [props.refreshInterval]);

    useEffect(() => {
        if (refreshPaused || props.refreshInterval <= 0) return;
        const intervalId = setInterval(() => {
            setRemainingTime(prev => {
                if (prev <= 1) {
                    props.onRefresh(props.vuid,props.drillThruObjRef.data_vuTempId, FoundationsConstants.enumVUCallerType.AutoRefresh, null, false, null, null, true); // Call to the parent refresh function
                    return props.refreshInterval * 60; // Reset timer after refresh
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(intervalId);
    }, [refreshPaused, props.refreshInterval]);

    // Derive minutes and seconds for display
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;

    return (
        <span id={'refresh_panel_' + props.vuid} style={{ display: 'inline-block' }}>
            <span id={'refresh_label_' + props.vuid}>
                {refreshPaused ? 'AutoRefresh Paused at' : 'Refreshing Drillthru in'}:
                {minutes < 10 ? ` 0${minutes}` : minutes}m:
                {seconds < 10 ? `0${seconds}` : seconds}s
            </span>
            <span
                onClick={toggleDrillthruAutoRefresh}
                id={'refresh_pause_toggle_' + props.vuid}
                className="toggleAutoRefresh"
                style={{ marginLeft: '10px', cursor: 'pointer', color: 'blue' }}
            >
                {refreshPaused ? 'continue autorefresh' : 'pause autorefresh'}
            </span>
        </span>
    )
}

export default AutoRefreshTimer